/**
 * @author: subhasish.ghosh@zoom.us
 */

import React, { useEffect, useState } from "react";
import { interval } from "rxjs";
import { map, take } from "rxjs/operators";

const useCountdown = (onComplete, timeLimit = 5) => {
  const [timer, setTimer] = useState(timeLimit);

  useEffect(() => {
    const countdown$ = interval(1000).pipe(
      take(timeLimit),
      map((value) => timeLimit - value)
    );

    const subscription = countdown$.subscribe({
      next: setTimer,
      complete: onComplete,
    });

    return () => subscription.unsubscribe();
  }, [onComplete, timeLimit]);

  return timer;
};

export const countdownObserver = (onNext, onComplete, timeLimit = 5) => {
  const countdown$ = interval(1000).pipe(
    take(timeLimit + 1),
    map((value) => timeLimit - value)
  );

  const subscription = countdown$.subscribe({
    next: (value) => {
      onNext(value);
    },
    complete: onComplete,
  });

  return subscription;
};

export default useCountdown;
